// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bNzP","toggleWrap":"styles_toggleWrap__1wc8q","content":"styles_content__2fFA0","selectAreaCode":"styles_selectAreaCode__GnXnb"};